export default "__VITE_ASSET__C49_0A6z__"